import React from "react";
import { ConfigProvider } from "antd";
import zhCN from "antd/lib/locale/zh_CN";

import "dayjs/locale/zh-cn";
// import locale from "antd/locale/zh_CN";
import styles from "@/App.module.less";
import Router from "@/router";
import "@/i18n";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import relatieTime from "dayjs/plugin/relativeTime";
import dayjs from "dayjs";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relatieTime);

export { dayjs };

function App() {
  return (
    <ConfigProvider locale={zhCN}>
      <div className={styles.App}>
        <Router />
      </div>
    </ConfigProvider>
  );
}

export default App;
